import { memo } from 'react';

import ValidationFilledIconSVG from '@/assets/validation-filled-icon.svg?react';
import { ComponentContextProps, merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type ValidationFilledLogoProps = LogoProps & Partial<ComponentContextProps>;

const IValidationFilledLogo = ({ variant, className, ...rest }: ValidationFilledLogoProps) => {
  return (
    <Logo variant={variant} className={merge(className, 'bg-teal-500 text-white')} {...rest}>
      <ValidationFilledIconSVG />
    </Logo>
  );
};

export const ValidationFilledLogo = memo(IValidationFilledLogo) as typeof IValidationFilledLogo;
